import {CommonMessages} from '../common.messages';

export const ClientUsersMessages = {
    GetReportFailed: {
        key: 'GetReportFailed',
        message: 'Error while server communication. Unable to get users report.'
    },
    ...CommonMessages
};
